var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogosTelegram = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1103_6604)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 0C8.81812 0 5.76375 1.26506 3.51562 3.51469C1.2652 5.76522 0.000643966 8.81734 0 12C0 15.1813 1.26562 18.2357 3.51562 20.4853C5.76375 22.7349 8.81812 24 12 24C15.1819 24 18.2362 22.7349 20.4844 20.4853C22.7344 18.2357 24 15.1813 24 12C24 8.81869 22.7344 5.76431 20.4844 3.51469C18.2362 1.26506 15.1819 0 12 0Z",
  fill: "url(#paint0_linear_1103_6604)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.43477 11.8733C8.93352 10.3493 11.266 9.34454 12.4323 8.85904C15.766 7.47285 16.4579 7.2321 16.9098 7.22395C17.0091 7.22235 17.2304 7.24692 17.3748 7.36364C17.4948 7.46207 17.5285 7.5952 17.5454 7.68867C17.5604 7.78204 17.581 7.99485 17.5641 8.16098C17.3841 10.0585 16.6023 14.6631 16.2048 16.7884C16.0379 17.6877 15.706 17.9892 15.3854 18.0186C14.6879 18.0827 14.1591 17.5581 13.4841 17.1158C12.4285 16.4234 11.8323 15.9925 10.8066 15.3169C9.62165 14.5362 10.3904 14.107 11.0654 13.4057C11.2416 13.2222 14.3129 10.4294 14.371 10.176C14.3785 10.1444 14.386 10.0262 14.3148 9.96398C14.2454 9.90154 14.1423 9.92292 14.0673 9.93979C13.9604 9.96379 12.2748 11.079 9.00477 13.2854C8.52665 13.6142 8.09352 13.7745 7.70352 13.7661C7.27602 13.7569 6.45102 13.5239 5.8379 13.3247C5.0879 13.0804 4.48977 12.9512 4.54227 12.5363C4.56852 12.3203 4.86665 12.0992 5.43477 11.8733Z",
  fill: "white"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_1103_6604",
  x1: 1200,
  y1: 0,
  x2: 1200,
  y2: 2400,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2AABEE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#229ED9"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1103_6604"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogosTelegram);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logos_telegram.e78f7156e8ee0f303fc2374f8657af7e.svg";